import React from "react";
import DefaultLoader from "react-loader-spinner";
import styled from "styled-components";

const Wrapper = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Loader = () => (
  <Wrapper>
    <DefaultLoader type="Puff" color="#1F1F1F" height="100" width="100" />
  </Wrapper>
);

export default Loader;



// WEBPACK FOOTER //
// ./src/elements/Loader.js